export function convertTimestampToDay(timestamp) {
    //                      1sec -> 1min -> 1hora -> 1dia
    const timestampPerDay = 1000 * 60 * 60 * 24;

    //                      1sec -> 1min -> 1hora
    const timestampPerHour = 1000 * 60 * 60;

    const day = Math.floor(timestamp / timestampPerDay);

    //Arredondar para o mais proximo, pode gerar dois erros
    //Ex: hour = 23.9 --> 24
    //Ex: hour = 0.1 --> 0
    //Nos dois casos a hora é inválida, e por isto será tratada abaixo
    let hour = Math.round(
        (timestamp % timestampPerDay) / timestampPerHour
    );

    //Impede que um valor superior a 23 na varivel hour
    hour = hour > 23 ? 23 : hour;
    //Impede que um valor inferior a 1 na varivel hour
    hour = hour < 1 ? 1 : hour;

    if (Number.isNaN(day) || Number.isNaN(hour))
        return "Não há ocorrências em análise";

    if (day > 0)
        return String(day).padStart(2, "0") + " dia(s) e " + String(hour).padStart(2, "0") + " horas";

    return String(hour).padStart(2, "0") + " hora(s)";
}
